import { Buildings, X } from '@phosphor-icons/react';
import { LineupRow } from './LineupRow';

const Legend = () => (
  <div className="flex flex-wrap gap-2 text-[10px] font-black uppercase tracking-wider" data-testid="status-legend">
    <span className="px-2 py-0.5 rounded bg-[#4ADE80] text-black border border-black">Top · Going / Selected</span>
    <span className="px-2 py-0.5 rounded bg-[#FDE047] text-black border border-black">Middle · Pending / No Response / Will Inform</span>
    <span className="px-2 py-0.5 rounded bg-[#F87171] text-white border border-black">Bottom · Not Going / Not Selected</span>
  </div>
);

export const LineupTable = ({ rows, company, onClearCompany, readOnly, today, showDate = false, isOwner, onStatusChange, onDelete, onSendToTracker }) => (
  <div className="bg-[#0F3622] border-2 border-[#A3E635] rounded-md shadow-[4px_4px_0px_0px_rgba(163,230,53,0.3)] overflow-hidden" data-testid="lineup-table-wrap">
    <div className="flex flex-wrap items-center gap-3 px-4 py-3 border-b-2 border-[#143E29]">
      <Buildings size={22} weight="duotone" className="text-[#A3E635]" />
      <h2 className="text-base md:text-lg font-black text-white" data-testid="lineup-table-title">
        {company ? company : 'All companies'} <span className="text-[#A3E635]">({rows.length})</span>
      </h2>
      {company && (
        <button data-testid="clear-company" onClick={onClearCompany} className="flex items-center gap-1 px-2 py-1 bg-white text-black border-2 border-black rounded text-[11px] font-bold hover:-translate-y-0.5 transition-all">
          <X size={12} weight="bold" /> Show all companies
        </button>
      )}
      <div className="ml-auto"><Legend /></div>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full" data-testid="lineup-table">
        <thead>
          <tr className="bg-[#143E29] text-[#A3E635] text-[10px] uppercase tracking-wider text-left">
            <th className="px-3 py-2">Candidate</th>
            <th className="px-3 py-2">Mobile</th>
            <th className="px-3 py-2">Role</th>
            <th className="px-3 py-2">Company</th>
            <th className="px-3 py-2">Status</th>
            <th className="px-3 py-2">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-black/40">
          {rows.length === 0 ? (
            <tr><td colSpan={6} className="px-3 py-8 text-center text-white font-bold" data-testid="lineup-table-empty">No candidates match.</td></tr>
          ) : rows.map((r) => (
            <LineupRow key={r.id} row={r} readOnly={readOnly || (!!today && r.date < today)} showDate={showDate} isOwner={isOwner} onStatusChange={onStatusChange} onDelete={onDelete} onSendToTracker={onSendToTracker} />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
